// extracted by mini-css-extract-plugin
module.exports = {"name":"aDpN9sVgAXY_X3BL3ehQV","capacity":"_31q69mwriV0fzLEFghUSz5","pricing":"_1Q9o6EwBDr0Ar3iB3SJ1MO"};